module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	"use strict";
	fox.registerWidget('Promo_Header', {
		
		configure: function () {

			this.registerOptions('', {
				autoRender: true,
				container: '.common-header',
				template: 'promo_header',
				templateOptions: {
					member: fox.site.member
				},

				widgets: {
					langSwitcher: {
						widget: 'LangSwitcher'
					}
				},

				'handleDom.openMobileMenu': {
					target: '.open-mobile-menu-link',
					event: 'click',
					callback: fox.bind(function (el, alias, w, e) {
						el = fox.dom.wrap(el);
						var menu = fox.dom.wrap(this.dom1('#promo-top-menu'));

						el.hide();
						menu.addClass('showed');
					}, this)
				},

				'handleDom.toggleMobileMenu': {
					target: '.promo-top-menu',
					event: 'click',
					callback: fox.bind(function (el, alias, w, e) {
						var openLink = fox.dom.wrap(this.dom1('.open-mobile-menu-link'));
						var menu = fox.dom.wrap(el);

						openLink.node().style.display = '';
						menu.removeClass('showed');
					}, this)
				}
			});

			this.callParent('configure', arguments);
		},

		showCookiesSettingsPopup: function() {
			if (fox.Navigator.get(0) === 'cookie-policy') {
				this.wom1('@parent #cookiePolicy #cookiePolicy').showPopup();
			}
		}

	});
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/promo/header.js
// module id = 348
// module chunks = 2